import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-location",
  "use": "spr-location-usage",
  "viewBox": "0 0 75 74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 75 74\" id=\"spr-location\"><defs><path id=\"spr-location_a\" d=\"M931.95 1213h-72.92a1 1 0 0 1-.94-1.32l13.27-40a1 1 0 0 1 .95-.68h7.05c-2.07-4.49-3.18-8.7-3.18-12.36 0-10.83 8.66-19.64 19.3-19.64 10.65 0 19.31 8.81 19.31 19.64 0 3.67-1.1 7.87-3.18 12.36h7.06a1 1 0 0 1 .94.68l13.28 40a1 1 0 0 1-.94 1.32zm-58.93-40l-12.61 38h70.15l-12.61-38h-7.31c-3.2 6.2-8.13 12.84-14.44 19.28l-.71.72-.71-.72c-6.31-6.44-11.25-13.08-14.44-19.28zm22.47-32c-9.55 0-17.31 7.91-17.31 17.64 0 8.5 6.45 20.22 17.3 31.5 10.86-11.28 17.32-23 17.32-31.5 0-9.73-7.77-17.64-17.31-17.64zm0 27a9 9 0 0 1 0-18 9 9 0 0 1 0 18zm0-16a7 7 0 0 0 0 14 7 7 0 0 0 0-14zm12.94 49h-25.89a1 1 0 0 1 0-2h25.9a1 1 0 0 1 .99 1 1 1 0 0 1-1 1z\" /></defs><use fill=\"#fff\" xlink:href=\"#spr-location_a\" transform=\"translate(-858 -1139)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/location.svg
// module id = 261
// module chunks = 0